import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private cache = new Map<string, HttpResponse<any>>();

  constructor(private cookieService: CookieService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method !== 'GET') {
      this.cache.clear();
      return next.handle(request);
    }

    if (request.url.match(/sv=/)) {
      return next.handle(request);
    }

    const accessToken = this.cookieService.get('accessToken');
    if (accessToken) {
      request = request.clone({
        setHeaders: {
          'X-Frame-Options': 'SAMEORIGIN',
          'X-Content-Type-Options': 'nosniff',
          'Strict-Transport-Security': 'max-age=31536000',
          'Content-Security-Policy': 'default-src \'self\'',
          'Referrer-Policy': 'same-origin',
          'Permissions-Policy': 'geolocation=(self)',
          'Cross-Origin-Embedder-Policy': 'require-corp',
          'Cross-Origin-Resource-Policy': 'same-origin',
          'Cross-Origin-Opener-Policy': 'same-origin',
          Authorization: `Bearer ${accessToken}`
        }
      });
    }
    return next.handle(request);
  }
}
